import { GrowthOverviewGranularity, GrowthOverviewMetric } from "../const";
import type { TGrowthOverviewRowType } from "../types";

export const isCategoryWeeklyUniqueUnavailable = (
    granularity: GrowthOverviewGranularity,
    metric: GrowthOverviewMetric,
    rowType: TGrowthOverviewRowType,
): boolean =>
    granularity === GrowthOverviewGranularity.Weekly && metric === GrowthOverviewMetric.Unique && rowType !== "domain";
